import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { GrUserPolice } from "react-icons/gr";

function AboutHero6() {
  return (
    <>
    <div className="bg-white">
      <div className="mx-5  lg:mx-16 py-10">
        <div className="flex flex-col lg:flex-row justify-between align-middle items-start lg:items-center">
          <div className="text-[3.75rem] leading-[4.066rem] font-[700] text-[#142958] pb-5">
            Our Providers
          </div>
          <div className="flex justify-between align-middle items-center gap-3 bg-[#01cab8] border border-[#01cab8] py-5 px-6 font-[500] text-white hover:bg-[#fff] hover:text-[#02e2be]">
            <h1 className="ht">
              <GrUserPolice color="white" className="" size={18} />
            </h1>
            <button className="">All Providers</button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10  mt-5">
          <div className="col-span-1 shadow-md hover:shadow-2xl transition ease-in-out delay-150  border border-gray-100  rounded-xl">
            <div>
              <img
                className="w-full h-80 lg:h-60 rounded-t-xl "
                src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1683198590/card_image_home_03-02_jq5n2i.jpg"
              />
              <div className="p-5 mb-5">
                <div className="text-[.9375rem] font-[700] leading-3 py-2 text-[#01cab8]">
                  CARDIOLOGY
                </div>
                <div className="text-[2rem] font-[400] text-gray-700 border-b border-gray-300 pb-2">
                  Barbara <span className="font-bold">Hodgin</span>{" "}
                </div>
                <p className="text-gray-400 my-2 text-[14px]">
                  In publishing and graphic design, Lorem ipsum is a placeholder
                  text commonly used to demonstrate the visual form of a
                  document
                </p>
                <div className="flex justify-between align-middle items-center">
                  <div className="flex gap-4 justify-start my-5">
                    <div className="relative border  rounded-full border-[#01cab8] fill-[#01cab8] hover:fill-white cursor-pointer hover:bg-[#01cab8]  p-1.5 h-8 w-8 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="ionicon"
                        viewBox="0 0 512 512"
                      >
                        <path d="M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"></path>
                        <path d="M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z"></path>
                      </svg>
                    </div>
                    <div className="relative border  rounded-full border-[#01cab8] fill-[#01cab8] hover:fill-white cursor-pointer hover:bg-[#01cab8]  p-1.5 h-8 w-8 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="ionicon"
                        viewBox="0 0 512 512"
                      >
                        <path d="M508.64 148.79c0-45-33.1-81.2-74-81.2C379.24 65 322.74 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149 1 184.59-.06 220.19 0 255.79q-.15 53.4 3.4 106.9c0 45 33.1 81.5 73.9 81.5 58.2 2.7 117.9 3.9 178.6 3.8q91.2.3 178.6-3.8c40.9 0 74-36.5 74-81.5 2.4-35.7 3.5-71.3 3.4-107q.34-53.4-3.26-106.9zM207 353.89v-196.5l145 98.2z"></path>
                      </svg>
                    </div>
                  </div>
                  <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1">
                    <div className="">Read More </div>
                    <div className="mt-1">
                      <BsArrowRightShort size={20} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-1 shadow-md hover:shadow-2xl transition ease-in-out delay-150  border border-gray-100  rounded-xl">
            <div>
              <img
                className="w-full h-80 lg:h-60 rounded-t-xl "
                src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1683198590/card_image_home_03-02_jq5n2i.jpg"
              />
              <div className="p-5 mb-5">
                <div className="text-[.9375rem] font-[700] leading-3 py-2 text-[#01cab8]">
                  CARDIOLOGY
                </div>
                <div className="text-[2rem] font-[400] text-gray-700 border-b border-gray-300 pb-2">
                  Barbara <span className="font-bold">Hodgin</span>{" "}
                </div>
                <p className="text-gray-400 my-2 text-[14px]">
                  In publishing and graphic design, Lorem ipsum is a placeholder
                  text commonly used to demonstrate the visual form of a
                  document
                </p>
                <div className="flex justify-between align-middle items-center">
                  <div className="flex gap-4 justify-start my-5">
                    <div className="relative border  rounded-full border-[#01cab8] fill-[#01cab8] hover:fill-white cursor-pointer hover:bg-[#01cab8]  p-1.5 h-8 w-8 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="ionicon"
                        viewBox="0 0 512 512"
                      >
                        <path d="M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"></path>
                        <path d="M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z"></path>
                      </svg>
                    </div>
                    <div className="relative border  rounded-full border-[#01cab8] fill-[#01cab8] hover:fill-white cursor-pointer hover:bg-[#01cab8]  p-1.5 h-8 w-8 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="ionicon"
                        viewBox="0 0 512 512"
                      >
                        <path d="M508.64 148.79c0-45-33.1-81.2-74-81.2C379.24 65 322.74 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149 1 184.59-.06 220.19 0 255.79q-.15 53.4 3.4 106.9c0 45 33.1 81.5 73.9 81.5 58.2 2.7 117.9 3.9 178.6 3.8q91.2.3 178.6-3.8c40.9 0 74-36.5 74-81.5 2.4-35.7 3.5-71.3 3.4-107q.34-53.4-3.26-106.9zM207 353.89v-196.5l145 98.2z"></path>
                      </svg>
                    </div>
                  </div>
                  <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1">
                    <div className="">Read More </div>
                    <div className="mt-1">
                      <BsArrowRightShort size={20} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-1 shadow-md hover:shadow-2xl transition ease-in-out delay-150  border border-gray-100  rounded-xl">
            <div>
              <img
                className="w-full h-80 lg:h-60 rounded-t-xl "
                src="https://res.cloudinary.com/dt0j68vdr/image/upload/v1683198590/card_image_home_03-02_jq5n2i.jpg"
              />
              <div className="p-5 mb-5">
                <div className="text-[.9375rem] font-[700] leading-3 py-2 text-[#01cab8]">
                  CARDIOLOGY
                </div>
                <div className="text-[2rem] font-[400] text-gray-700 border-b border-gray-300 pb-2">
                  Barbara <span className="font-bold">Hodgin</span>{" "}
                </div>
                <p className="text-gray-400 my-2 text-[14px]">
                  In publishing and graphic design, Lorem ipsum is a placeholder
                  text commonly used to demonstrate the visual form of a
                  document
                </p>
                <div className="flex justify-between align-middle items-center">
                  <div className="flex gap-4 justify-start my-5">
                    <div className="relative border  rounded-full border-[#01cab8] fill-[#01cab8] hover:fill-white cursor-pointer hover:bg-[#01cab8]  p-1.5 h-8 w-8 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="ionicon"
                        viewBox="0 0 512 512"
                      >
                        <path d="M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z"></path>
                        <path d="M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z"></path>
                      </svg>
                    </div>
                    <div className="relative border  rounded-full border-[#01cab8] fill-[#01cab8] hover:fill-white cursor-pointer hover:bg-[#01cab8]  p-1.5 h-8 w-8 ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="ionicon"
                        viewBox="0 0 512 512"
                      >
                        <path d="M508.64 148.79c0-45-33.1-81.2-74-81.2C379.24 65 322.74 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149 1 184.59-.06 220.19 0 255.79q-.15 53.4 3.4 106.9c0 45 33.1 81.5 73.9 81.5 58.2 2.7 117.9 3.9 178.6 3.8q91.2.3 178.6-3.8c40.9 0 74-36.5 74-81.5 2.4-35.7 3.5-71.3 3.4-107q.34-53.4-3.26-106.9zM207 353.89v-196.5l145 98.2z"></path>
                      </svg>
                    </div>
                  </div>
                  <div className="flex text-[#01cab8] justify-start align-middle items-center gap-1">
                    <div className="">Read More </div>
                    <div className="mt-1">
                      <BsArrowRightShort size={20} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default AboutHero6;
